<template>
    <div class="files-processing">
    
        <h2 v-if="value > 0">{{ hebrew? 'הקבצים בתהליך עיבוד': 'Files are currently being processed' }}</h2>
        <h2 v-else>{{ hebrew ? 'תהליך עיבוד הקבצים טרם התחיל' : 'Files in queue' }}</h2>
        <span>{{hebrew? 'בסיום העבודה ישלח קישור לקובץ המעובד לדוא״ל שהזנת': 
        'When your file is ready, a download link will be sent to your email address' }}</span>

        <div class="progress-wrap position-relative">
            <small class="position-absolute text-muted mt-n4" :style="{ right: value > 0 ? value-8 : 0 + '%' }">{{ value }}%</small>
            <b-progress :value="value" :max="max">
            </b-progress>
        </div>
      
    </div>
</template>
<script>
export default {
    name: "FiledProcessing",
    data() {
        return {
            max: 100
        }
    },
    computed: {
        hebrew() {
            return this.$settings.hebrew
        },
        value () {
            let sum = 0
            if (this.$store.state.uploadStatus.progress_results) {
                this.$store.state.uploadStatus.progress_results.map(item=> {sum += item.progress})
                sum = sum / this.$store.state.uploadStatus.progress_results.length
            }
            return (Math.round(sum * 100))
        }
    }
}
</script>    